/**
 * A picked day as the list filters take it: `Y-m-d` only. `/auctions` and `/bids` refuse a time with it (422), and
 * `to` already counts the whole day it names — `from` = `to` = today finds today's.
 */
export function toFilterDate(value: string) {
  const day = value.trim().slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : undefined;
}
